import React from 'react';
import { Avatar } from 'antd';

const renderAvatar = props => {
  return (
    <Avatar {...props} className={`ant-avatar-${props.type}`}>
      {props.text}
    </Avatar>
  );
};

export const AvatarStatus = props => {
  const {
    name,
    suffix,
    subTitle,
    type,
    src,
    icon,
    size,
    shape,
    gap,
    text,
    inverted,
    style,
  } = props;
  return (
    <div className="avatar-status d-flex align-items-center" style={style && style}>
      <>
        {!inverted && renderAvatar({ icon, src, type, size, shape, gap, text })}
        <div className={`${inverted ? 'mr-2' : 'ml-2'}`}>
          <div>
            <div className="avatar-status-name" style={{ fontSize: size ? `${size / 2}px` : null }}>
              {name}
            </div>
            <span>{suffix}</span>
          </div>
          <div className="text-muted avatar-status-subtitle">{subTitle}</div>
        </div>
        {inverted && renderAvatar({ icon, src, type, size, shape, gap, text })}
      </>
    </div>
  );
};

export default AvatarStatus;
